import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { makeStyles, withStyles } from "@mui/styles";
import Paper from "@mui/material/Paper";
import { Grid, Typography, TextField, Button } from "@mui/material";
import {
    CoachProfileProvider,
    CoachProfileConsumer,
    AdminCoachProfileContext
} from  "../../../common/AdminCoachProfileContext";
import ProfileDetailsEdit from "./ProfileDetailsEditSectionContainer";
import clsx from "clsx";
import { darkenColor } from "../../../utils/appHelper";
import CoachProfileSummary from "../../../sharedComponents/CoachProfileSummary/CoachProfileSummary";

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
    },
    grid: {
        display: "flex",
        flexGrow: 1,
        flexWrap: "wrap",
        paddingTop: theme.spacing(1),
        [theme.breakpoints.up("sm")]: {
            padding: theme.spacing(1),
        },
        [theme.breakpoints.down("xs")]: {
            padding: 0,
            flexGrow: 0,
        },
    },
    section: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(3),
        textAlign: "left",
        padding: "5px 25px",
    },
    gridItem: {
        [theme.breakpoints.up("sm")]: {
            padding: theme.spacing(1),
        },
        [theme.breakpoints.down("xs")]: {
            width: "100%",
            paddingBottom: theme.spacing(2),
        },
    },
    profileSummary: {
        paddingBottom: theme.spacing(2),
        minHeight: "300px",
        boxShadow: '0px 0px 5px rgba(6, 37, 91, .2)',
        borderRadius: '0',
        backgroundColor: theme.palette.mode === 'dark' ? darkenColor(theme.palette.background.default, 25) : theme.palette.primary.dark
    },
    profileDetails: {
        textAlign: "left",
        color: theme.palette.text.secondary,
        borderRadius: '0',
    },
    submitButton: {
        alignContent: "center",
        textAlign: "center",
        paddingBottom: 10,
        paddingRight: 10,
    },
}));

const ProfileEditMainContainer = (props) => {
    let isViewMode = false;
    const routeParams = useParams();
    // Support both router params and dialog props
    let params = props.dialogUsername || routeParams.userName;
    
    const classes = useStyles();
    return (
        <CoachProfileProvider>
            <CoachProfileConsumer>
                {(props) => {
                    return (
                        <div className={classes.root}>
                            <Grid container className={classes.grid}>
                                <Grid size={{ xs: 12, sm: 3, md: 3 }} className={classes.gridItem}>
                                    <CoachProfileSummury isViewMode={isViewMode} showBackButton={true} />
                                </Grid>

                                <Grid size={{ xs: 12, sm: 9, md: 9 }} className={classes.gridItem}>
                                    <Paper className={clsx(classes.profileDetails, "custom-view")}>
                                        <ProfileDetailsEdit params={params} />
                                    </Paper>

                                </Grid>
                            </Grid>
                        </div>)
                }}
            </CoachProfileConsumer>
        </CoachProfileProvider>
    );
}


const CoachProfileSummury = (props) => {
    const contextValue = useContext(AdminCoachProfileContext);
    return <CoachProfileSummary isViewMode={props.isViewMode} showBackButton={props.showBackButton} contextValue={contextValue} />;
};

export default ProfileEditMainContainer;